import epicTracking from 'epic-tracking';
import React, {useState} from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import BattlePassBadge from './BattlePassBadge';
import BattlePassSection from './BattlePassSection';
import FeatureCarousel from './FeatureCarousel';
import FeatureHeroTitle from './FeatureHeroTitle';
import StyledHeroFlexContainer from './StyledHeroFlexContainer';
import {CmsData} from './Types';

interface Props {
  data: CmsData;
  mobile: boolean;
  tablet: boolean;
}
const FeatureHeroCarousel = ({data, mobile, tablet}: Props) => {
  const [activeSlide, setActiveSlide] = React.useState(0);
  const [visible, setVisibility] = useState(false);
  const {
    title,
    items,
    subtitle,
    badge,
    badgeAlt,
    seasonKey,
    mainHeroBackgroundImg,
    mobileHeroBackgroundImg,
  } = data;

  const spike = items && items[activeSlide]?.spike;
  const spikeRight = items && items[activeSlide]?.spikeRight;

  const setSectionVisibility = React.useCallback(
    (visibility) => {
      setVisibility(visibility);
      if (visibility) {
        epicTracking.trackEvent('Interaction', {
          interactionType: 'scrollViewSection',
          eventCategory: 'BattlePass Feature Hero',
          eventAction: 'featureHero-inView',
        });
      }
    },
    [setVisibility]
  );

  const setCurrentSlide = React.useCallback(
    (activeSlide) => {
      setActiveSlide(activeSlide);
    },
    [setActiveSlide]
  );

  //hides section if cms content isn't there
  if (!items || items.length === 0) return null;

  return (
    <BattlePassSection seasonKey={seasonKey}>
      <BattlePassBadge image={badge} imageAlt={badgeAlt} />
      <StyledHeroFlexContainer
        className="hero-carousel"
        bkImg={mobile ? mobileHeroBackgroundImg : mainHeroBackgroundImg || null}>
        <FeatureHeroTitle
          mobile={mobile}
          tablet={tablet}
          seasonKey={seasonKey}
          title={title}
          subtitle={subtitle}
          spike={spike}
          spikeRight={spikeRight}
        />
        <VisibilitySensor onChange={setSectionVisibility} partialVisibility minTopValue={0}>
          <FeatureCarousel
            seasonKey={seasonKey}
            mobile={mobile}
            tablet={tablet}
            isVisible={visible}
            activeSlide={activeSlide}
            setCurrentSlide={setCurrentSlide}
            items={items}
          />
        </VisibilitySensor>
      </StyledHeroFlexContainer>
    </BattlePassSection>
  );
};

export default FeatureHeroCarousel;
